module.exports = __webpack_public_path__ + "static/media/logo-blue.9e2b0ca6.svg";